import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import {brandDetector} from '@/brands';

let brandStyles = brandDetector();


//CARGA DE LA FUENTE
if(!!brandStyles.fonts){
	var head = document.head;
	var link = document.createElement("link");
	link.type = "text/css";
	link.rel = "stylesheet";
	link.href = 'https://fonts.googleapis.com/css?'+brandStyles.fonts.link;
	head.appendChild(link);
}


if(!!brandStyles.ownstyles){
	var head = document.head;
	var link = document.createElement("link");
	link.type = "text/css";
	link.rel = "stylesheet";
	link.href = brandStyles.ownstyles;
	head.appendChild(link);
}

const styles = {
	state: brandStyles,
	getters: {
		getLogo : state => state.logo,
		getLogoColor : state => state.logocolor,
		getDocSuperior : state => state.docDescargaMenu,
		getmensajeAntesEvaluar : state => state.mensajeAntesEvaluar,
		getEncabezados: state => state.encabezados,
		getBrand : state => state,
		getFonts : state =>{
			if(state.fonts){
				return state.fonts
			}else {
				let fonts = {
					principal : "'Lato', sans-serif",
					secundaria : "'Nunito', sans-serif"
				}
				return fonts;
			}
		},
		basicColors : (state, getters) => {

			let colors;

			let how = 'default';

			colors = {
				basic : state.basic[how],
				backgroundMenu : state.backgrounds.menu,
				backgroundBody : state.backgrounds.body,
				basicAlternative : state.basic.alternative,
				fontAlternative : state.basic.fontAlternative,
				button : state.button[how],
				buttonFont : state.button.font,
				soft_basic : state.soft_basic[how],
				white : state.white[how],
				dark_black : state.dark_black[how],
				medium_black : state.medium_black[how],
				soft_black : state.soft_black[how],
				light_black : state.light_black[how],
				text_black : state.text_black[how],
			}

			return colors; 

		},
		getStyles : (state, getters) => {
			return {
				colorBasic : {
					color : getters.basicColors.basic
				},
				colorSoftBasic : {
					color : getters.basicColors.basic
				},
				colorButton : {
					color : getters.basicColors.button
				},
				colorWhite : {
					color : getters.basicColors.white
				},
				colorTextBlack : {
					color : getters.basicColors.text_black
				},
				colorDarkBlack : {
					color : getters.basicColors.dark_black
				},
				colorMediumBlack : {
					color : getters.basicColors.medium_black
				},
				colorSoftBlack : {
					color : getters.basicColors.soft_black
				},
				colorLightBlack : {
					color : getters.basicColors.light_black
				},
				fontColorButton :{
					color : getters.basicColors.buttonFont
				},
				titleSection : {
					color : getters.basicColors.basic,
					'border-bottom' : `.5px solid ${getters.basicColors.soft_black}`
				},
				subtitle_section : {
					background : getters.basicColors.light_black
				},
				solidPrimary : {
					'background-color' : getters.basicColors.button,
					color : getters.basicColors.buttonFont,
					border : `2px solid ${getters.basicColors.button}`,
					'font-family' : getters.getFonts.secundaria
				},
				solidWhite : {
					'background-color' : getters.basicColors.white,
					border : `2px solid ${getters.basicColors.white}`,
					color : getters.basicColors.basic,
					'font-family' : getters.getFonts.secundaria
				},
				skull_primary : {
					color : getters.basicColors.basic,
					border : `2px solid ${getters.basicColors.basic}`,
					'font-family' : getters.getFonts.secundaria
				},
				skull_white : {
					color : getters.basicColors.white,
					border : `2px solid ${getters.basicColors.white}`,
					'font-family' : getters.getFonts.secundaria
				},
				skull_primary_ghost : {
					color : getters.basicColors.basic,
					border : `2px solid ${getters.basicColors.basic}`,
					opacity : '0.7',
					'pointer-events' : 'none',
					'font-family' : getters.getFonts.secundaria
				},
				tips : {
					'border-right' : `1px solid ${getters.basicColors.basic}`
				},
				input_black : {
					'border-bottom' : `1px solid ${getters.basicColors.medium_black}`
				},
				textarea : {
					'border-bottom' : `1px solid ${getters.basicColors.medium_black}`,
					background : getters.basicColors.light_black
				}, 
				contenedor_imagen : {
					background : getters.basicColors.soft_black
				},
				skull_tag : {
					color : getters.basicColors.basic,
					border : `1px solid ${getters.basicColors.basic}`
				},
				backgroundWhite : {
					background : getters.basicColors.white	
				},
				bgBasic : {
					background : getters.basicColors.basic	
				},
				bgmenu : {
					background : getters.basicColors.backgroundMenu	
				},
				bgbody : {
					background : getters.basicColors.backgroundBody	
				},
				bgSoftBasic : {
					background : getters.basicColors.soft_basic	
				},
				colorWhite : {
					color : getters.basicColors.white	
				},
				fontSecondary : {
					'font-family' : getters.getFonts.secundaria
				},
				colorAlternative : {
					color : (!!getters.basicColors.basicAlternative) ? getters.basicColors.basicAlternative : getters.basicColors.basic
				}
			}
		},
		getFooterText : state => {
			if(!!state.footer){
				return state.footer.textos
			}
		},
		getFooterLinks : state => {
			if(!!state.footer){
				return state.footer.links
			}
		},
		getBackground : state => {
			if(!!state.background){
				return state.background;
			}
		},
		getPDFPropuestaPracticas : state => {
			if(!!state.instruccionesPropuestaPracticas){
				return state.instruccionesPropuestaPracticas;
			}
		},
		getOwnlogin : state => {
			if(!!state.ownlogin){
				return state.ownlogin;
			}
		},
		getInMantenimiento : state => {
			if(!!state.inMantenimiento){
				return state.inMantenimiento
			}
		},
		getAnalitycs : state => {
			if(!!state.analitycs){
				return state.analitycs
			}
		},
		getCanUploadDocPracticas : state => {
			if(!!state.canUploadDocPractica){
				return state.canUploadDocPractica
			}
		},
		getInProduction : state => {

			let inproduccion = false;

			if(!!state.dominio_produccion){
				if(state.dominio_produccion == location.hostname){
					inproduccion = true;
				}
			}
			
			return inproduccion
		}
	},
	actions: {
		getColors : function({commit}){

			var where;

			switch (location.hostname) {
				case 'demo-loca-front.dotia.es':
				where = '10cl2g';
				break;
				default:
				where = 'koo54';
				break;
			}

		}
	},
	mutations: {
		setStyles :function(state, data){
			state.basic = data.basic;
			state.dark_black = data.dark_black;
			state.medium_black = data.medium_black;
			state.soft_black = data.soft_black;
			state.light_black = data.light_black;
			state.white = data.white;
			(!!data.logo) ? state.logo = data.logo : '';
		}
	}
}

export default styles;



// WEBPACK FOOTER //
// ./src/store/styles.js